<!--
 * @Author:
 * @Description: 审核流程组件
-->
<template>
  <div class="h-full overflow-y-auto bg-[#f5f7fa] px-10px py-20px">
    <div class="mb-20px">
      <el-radio-group v-model="form.isPass" class="mb-20px" size="mini">
        <el-radio class="mr-0px" :label="1" border>同意</el-radio>
        <el-radio :label="0" border>作废</el-radio>
      </el-radio-group>
      <el-input
        v-model="form.opinion"
        placeholder="请输入意见/评论"
        clearable
        type="textarea"
        class="mb-10px"
      ></el-input>
      <el-button
        type="primary"
        size="mini"
        :loading="checkLoading"
        @click="handleWork"
        :disabled="form.isPass === null"
        >处理工作</el-button
      >
    </div>
    <div>
      <el-button type="primary" size="mini" class="mb-10px" @click="handleFlowDraw">
        查看流程图
      </el-button>
    </div>
    <!-- 流程节点 -->
    <div v-for="(item, index) in flowList" :key="index">
      <div class="flex text-14px relative">
        <div class="absolute left-15px h-full border-l-[1px] border-gray-300"></div>
        <div class="absolute flex justify-center items-center">
          <div class="w-30px h-30px leading-20px rounded-1/2 overflow-hidden">
            <img
              class="w-30px h-30px"
              :src="`${currentEnv.VUE_APP_DIY_AVATAR_PATH}${item.Avatar}`"
              alt=""
              v-if="item.Avatar"
            />
            <div class="w-30px h-30px bg-[#c0c4cc]" v-else></div>
          </div>
        </div>
        <div class="relative pl-40px pt-5px flex flex-col">
          <div class="flex-1">
            <div class="flex">
              <div class="mr-10px font-700 leading-20px">{{ item.Sender }}</div>
              <div
                v-if="item.ApprovalType && item.ApprovalType === 'Agree'"
                class="
                  mr-10px
                  text-[#14ce67]
                  p-2px
                  pl-5px
                  pr-5px
                  bg-[#e7faf0]
                  border-[#14ce67] border-1px
                  rounded-5px
                "
              >
                同意
              </div>
              <div
                v-if="item.ApprovalType && item.ApprovalType === 'Disagree'"
                class="
                  mr-10px
                  text-[#ff4f55]
                  p-2px
                  pl-5px
                  pr-5px
                  bg-[#ffeded]
                  border-[#fedede] border-1px
                  rounded-5px
                "
              >
                不同意
              </div>
              <div
                class="
                  text-[#1890ff]
                  p-2px
                  pl-5px
                  pr-5px
                  bg-[#e8f4ff]
                  border-[#d1e9ff] border-1px
                  rounded-5px
                "
              >
                {{ item.FromNodeName }}
              </div>
            </div>
            <div class="text-[#666] mt-10px">{{ item.ApprovalIdea }}</div>
            <div v-if="item.Receivers && item.Receivers.length > 0" class="mt-5px">
              <div class="w-full h-1px bg-[#dcdfe6] mt-20px mb-20px relative">
                <div class="absolute left-20px bg-[#f5f7fa] pl-20px pr-20px -top-10px">
                  <div
                    class="
                      h-20px
                      leading-16px
                      pl-5px
                      pr-5px
                      text-[#1890ff]
                      bg-[#e8f4ff]
                      border-[#d1e9ff] border-1px
                      rounded-5px
                    "
                  >
                    接收人
                  </div>
                </div>
              </div>
              <div>
                <div
                  class="mb-5px mr-5px flex inline-block float-left"
                  v-for="(access, aIndex) in item.Receivers"
                  :key="aIndex"
                >
                  <div
                    class="
                      h-24px
                      leading-20px
                      rounded-12px
                      bg-[#ffeded]
                      border-[#fedede] border-1px
                      text-[#ff4f55]
                      flex
                    "
                  >
                    <div class="w-20px h-20px leading-20px rounded-1/2 overflow-hidden">
                      <img
                        class="w-20px h-20px"
                        :src="`${currentEnv.VUE_APP_DIY_AVATAR_PATH}${access.Avatar}`"
                        alt=""
                        v-if="access.Avatar"
                      />
                      <div class="w-20px h-20px bg-[#c0c4cc]" v-else></div>
                    </div>
                    <div class="flex-1 pl-5px pr-5px">{{ access.Name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-[#999] mt-10px mb-10px h-14px">{{ item.CreateTime }}</div>
        </div>
      </div>
    </div>
    <!-- 查看流程图弹框 -->
    <el-dialog
      title="查看流程图"
      :visible.sync="dialogVisible"
      width="1200px"
      :close-on-click-modal="false"
      append-to-body
      v-dialogDrag
    >
      <manhattanGraph
        class="h-700px"
        :nodes="graphData.nodes"
        :edges="graphData.edges"
        v-if="dialogVisible"
      />
    </el-dialog>
  </div>
</template>

<script>
import dataRuleSettingService from '@/services/DataRuleSettingService'
import manhattanGraph from './manhattanGraph'

export default {
  name: 'workflow',
  components: { manhattanGraph },
  props: {
    processData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        opinion: '',
        isPass: null,
      },
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      dialogVisible: false,
      graphData: {
        nodes: [],
        edges: [],
      }, // grapg图数据
      flowList: [], // 流程节点数据
      checkLoading: false,
      workFlowData: {}, // 工作流数据
      WFWorkData: {}, // 工作数据
      // 节点列表
      nodeList: [
        {
          NodeName: '验收',
          Id: '1cf8784a-a9a9-4cf9-80ba-d039fd017288',
        },
        {
          NodeName: '整改',
          Id: '91f6f7cd-1082-4a6b-9c61-a1b5516ecfd7',
        },
        {
          NodeName: '签收',
          Id: 'cef71368-80d1-401d-b476-64d4ed48387f',
        },
        {
          NodeName: '生产技术部审核',
          Id: '08bebe8c-8df6-4c91-80ba-28ff374c6efc',
        },
        {
          NodeName: '安全环保部审核',
          Id: '280f982f-7ed4-4336-b73b-c87e6232b22f',
        },
        {
          NodeName: '上级审核',
          Id: '0cf54fdf-e00e-42fd-9c77-bfbf4f70e0e8',
        },
        {
          NodeName: '违章上报',
          Id: 'b254068f-988a-4270-8398-2be85c1ab0b4',
        },
      ],
      // 边数据
      edgeList: [
        {
          FromNodeId: '91f6f7cd-1082-4a6b-9c61-a1b5516ecfd7',
          ToNodeId: '1cf8784a-a9a9-4cf9-80ba-d039fd017288',
        },
        {
          FromNodeId: 'cef71368-80d1-401d-b476-64d4ed48387f',
          ToNodeId: '91f6f7cd-1082-4a6b-9c61-a1b5516ecfd7',
        },
        {
          FromNodeId: '08bebe8c-8df6-4c91-80ba-28ff374c6efc',
          ToNodeId: 'cef71368-80d1-401d-b476-64d4ed48387f',
        },
        {
          FromNodeId: '280f982f-7ed4-4336-b73b-c87e6232b22f',
          ToNodeId: 'cef71368-80d1-401d-b476-64d4ed48387f',
        },
        {
          FromNodeId: '0cf54fdf-e00e-42fd-9c77-bfbf4f70e0e8',
          ToNodeId: '08bebe8c-8df6-4c91-80ba-28ff374c6efc',
        },
        {
          FromNodeId: '0cf54fdf-e00e-42fd-9c77-bfbf4f70e0e8',
          ToNodeId: '280f982f-7ed4-4336-b73b-c87e6232b22f',
        },
        {
          FromNodeId: 'b254068f-988a-4270-8398-2be85c1ab0b4',
          ToNodeId: '0cf54fdf-e00e-42fd-9c77-bfbf4f70e0e8',
        },
      ],
    }
  },
  watch: {
    processData: {
      immediate: true,
      async handler(val) {
        if (val) {
          await this.getWorkflowRelation()
          await this.getWFWork()
          this.getWFHistory()
        }
      },
    },
  },
  created() {},
  methods: {
    // 获取工作流字段
    async getWorkflowRelation() {
      const res = await dataRuleSettingService.getWorkflowRelationInfo({
        authorizationClassId: this.processData.authorizationClassId,
      })
      if (res) this.workFlowData = res
    },
    async getWFWork() {
      const formData = new FormData()
      formData.append('FlowId', this.workFlowData.workFlowId)
      formData.append('WorkType', 'Todo')
      const res = await dataRuleSettingService.getWFWork(formData)
      if (res && res.Code === 1) {
        this.WFWorkData = res.Data[0]
        let isShow = false
        res.Data.length ? (isShow = true) : (isShow = false)
        this.$emit('showFlow', isShow)
      }
    },
    // 处理工作
    async handleWork() {
      if (this.form.isPass === 1) {
        this.passData()
      } else {
        this.rejectData()
      }
    },
    // 通过
    async passData() {
      this.checkLoading = true
      const res = await dataRuleSettingService.permissionsAudit({
        flowId: this.workFlowData.workFlowId,
        authorizationClassId: this.processData.authorizationClassId,
        opinion: this.form.opinion,
        isPass: true,
      })
      this.checkLoading = false
      if (res && res.code === 0) {
        this.$message.success('操作成功')
        this.getWFHistory()
        this.form = this.$options.data().form
        this.$emit('close', true)
      }
    },
    // 作废
    async rejectData() {
      this.checkLoading = true
      const res = await dataRuleSettingService.permissionsAuditCancel({
        workId: this.WFWorkData.Id,
        flowId: this.workFlowData.workFlowId,
        authorizationClassId: this.processData.authorizationClassId,
        opinion: this.form.opinion,
      })
      this.checkLoading = false
      if (res && res.code === 0) {
        this.$message.success('操作成功')
        this.getWFHistory()
        this.form = this.$options.data().form
        this.$emit('close', true)
      }
    },
    // 获取审批流程
    async getWFHistory() {
      const formData = new FormData()
      formData.append('FlowId', this.workFlowData.workFlowId)
      const res = await dataRuleSettingService.getWFHistory(formData)
      if (res && res.Code === 1) {
        this.flowList = _.map(res.Data, (item) => {
          item.Receivers = item.Receivers ? JSON.parse(item.Receivers) : []
          item.userList = [{ Id: item.SenderId, Name: item.Sender }].concat(item.Receivers)
          return item
        })
        this.getUserAvatar()
      }
    },
    // 获取用户头像
    async getUserAvatar() {
      let userList = []
      _.map(this.flowList, (item) => {
        userList = userList.concat(item.userList)
      })
      const formData = new FormData()
      _.forEach(userList, (item, index) => {
        formData.append(`Ids[${index}]`, item.Id)
      })
      const res = await dataRuleSettingService.getUserAvatar(formData)
      if (res && res.Code === 1) {
        _.map(this.flowList, (item) => {
          this.$set(item, 'Avatar', _.find(res.Data, ['Id', item.SenderId]).Avatar)
          _.map(item.Receivers, (uItem) => {
            this.$set(uItem, 'Avatar', _.find(res.Data, ['Id', uItem.Id]).Avatar)
            return uItem
          })
          return item
        })
      }
    },
    // 流程图节点
    async getNode() {
      this.nodeList = []
      const res = await dataRuleSettingService.getFlowNode({
        TableName: 'WF_Node',
        _SearchEqual: { FlowDesignId: this.workFlowData.workFlowDesignId },
      })
      if (res && res.Code === 1) {
        this.nodeList = res.Data
      }
    },
    // 流程图边
    async getEdge() {
      this.edgeList = []
      const res = await dataRuleSettingService.getFlowNode({
        TableName: 'WF_Line',
        _SearchEqual: { FlowDesignId: this.workFlowData.workFlowDesignId },
      })
      if (res && res.Code === 1) {
        this.edgeList = res.Data
      }
    },
    // 查看流程图, 处理流程图数据
    async handleFlowDraw() {
      await this.getNode()
      await this.getEdge()
      this.edgeList = this.edgeList.reverse()
      this.nodeList = this.nodeList.reverse()
      const edges = []
      const nodes = []
      _.map(this.edgeList, (item) => {
        edges.push({
          source: item.FromNodeId,
          target: item.ToNodeId,
        })
      })
      _.map(this.nodeList, (item, index) => {
        nodes.push({
          id: item.Id,
          label: item.NodeName,
          width: 200,
          height: 40,
          x: 40,
          y: 40 + index * 100,
          attrs: {
            body: {
              stroke: '#000', // 边框颜色
              rx: 7, // 横向圆角
              ry: 7, // 总项圆角
            }, // 外层body
          },
        })
      })
      _.map(nodes, (item, index) => {
        const toNodeList = _.filter(this.edgeList, (eItem) => {
          return eItem.ToNodeId === item.id
        })
        if (toNodeList.length > 1) {
          const y = item.y - 100 * toNodeList.length
          for (let i = 1; i <= toNodeList.length; i = i + 1) {
            nodes[index - i].x = 40 + 200 * toNodeList.length - i * 240
            nodes[index - i].y = y
          }
          const nextNodeLength = nodes.length - index
          for (let i = 0; i < nextNodeLength; i = i + 1) {
            nodes[index + i].y = nodes[index + i].y - 100 * (toNodeList.length - 1)
          }
        }
      })
      this.graphData = {
        nodes,
        edges,
      }
      this.dialogVisible = true
    },
  },
}
</script>
